// Styles
import styles from './ProductIcon.module.css';

export default function ProductIcon({ imageSource, marginRight = 0 }) {
  const containerStyles = {
    '--margin-right': `${marginRight}px`,
  };

  return (
    <div
      className={styles.container}
      style={containerStyles}
      data-core-qa="productIconContainer"
    >
      <img
        className={styles.productIcon}
        src={imageSource}
        alt="product icon"
        width="32"
        height="32"
        data-core-qa="productIconImage"
      />
    </div>
  );
}
